// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/vfr-ott-equipment.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/vfr-ott-equipment/vfr-ott-equipment.js';

mount([g0]);
